/* eslint-disable @typescript-eslint/no-var-requires */

const React = require("react");
const smoothscroll = require("smoothscroll-polyfill");
const { Cookies } = require("react-cookie-consent");
const Analytics = require("./src/utils/analytics");
const { COOKIE_NAME } = require("./src/utils/constants");
const { Layout } = require("./src/components/layout.tsx");
const { AppContainer } = require("./src/components/Context/AppContext");

exports.wrapPageElement = ({ element, props }) => {
  return (
    <AppContainer location={props.location}>
      <Layout {...props}>{element}</Layout>
    </AppContainer>
  );
};

exports.onClientEntry = () => {
  // kick off the polyfill!
  smoothscroll.polyfill();

  const consent = Cookies.get(COOKIE_NAME);

  if (consent && parseInt(consent)) {
    Analytics.loadScripts();
  }
};
